<div [ngClass]="'cc-add-delete-field'">
  <span class="sub-form-container">
    <ng-template ngFor let-formRecord [ngForOf]="formRecords" let-recordIndex="index">
      <p-card [class]="fieldValueMap['class-' + recordIndex]">
        <button *ngIf="formRichFieldConfig.addNew" pButton pRipple icon="fas fa-xmark"
                class="form-record-remove-btt p-button-text p-button-sm p-button-danger"
                (click)="delete(recordIndex);reloadFieldValueMap();this.formRecordsChange.emit(this.formRecords);"
                [disabled]="!fieldValueMap['canDelete']"></button>
        <span *ngIf="!formRichFieldConfig.addNew"
              class="form-record-remove-btt"></span>
        <app-cc-form #ccForm [transPartKey]="transPartKey"
                     [loading]="false" [submitted]="submitted"
                     [formConfig]="formRichFieldConfig.fields" [(formRecord)]="formRecords[recordIndex]"
                     (formRecordChange)="reloadFieldValueMap();this.formRecordsChange.emit(this.formRecords);"
        ></app-cc-form>
      </p-card>
    </ng-template>
  </span>
  <span class="add-button-container">
    <button *ngIf="formRichFieldConfig.addNew" pButton pRipple icon="pi pi-plus"
            class="form-record-add-btt button-left p-button-text p-button-sm p-button-success p-mr-2"
            (click)="formRichFieldConfig.addNew(formRecords);reloadFieldValueMap();
                  this.formRecordsChange.emit(this.formRecords);"
            [disabled]="!fieldValueMap['canAdd']"></button>
    <button *ngIf="formRichFieldConfig.addNew" pButton pRipple icon="pi pi-plus"
            class="form-record-add-btt button-right p-button-text p-button-sm p-button-success p-mr-2"
            (click)="formRichFieldConfig.addNew(formRecords);reloadFieldValueMap();
                  this.formRecordsChange.emit(this.formRecords);"
            [disabled]="!fieldValueMap['canAdd']"></button>
  </span>
</div>
